
import { useSupabaseCount, CountResult } from "./useSupabaseCount";

export function useBookingCount(): CountResult {
  return useSupabaseCount("bookings", "booking-count");
}
